var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25.5 29.1",
    style: {
      enableBackground: "new 0 0 25.5 29.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_497_1_",
    className: "st0",
    d: "M4.7,2.1H0.8V8c-0.1,1.8,1.3,3.4,3.1,3.5c0.2,0,0.6,0,0.8,0"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_73_1_",
    className: "st1",
    x1: 12.8,
    y1: 19.2,
    x2: 12.8,
    y2: 23.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_500_1_",
    className: "st0",
    d: "M20.9,2.1h3.9V8c0.1,1.8-1.3,3.4-3.1,3.5c-0.2,0-0.6,0-0.8,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_501_2_",
    className: "st2",
    d: "M20.9,0.8v10.8c0,0,0.2,7.7-8.1,7.7s-8.1-7.7-8.1-7.7V0.8H20.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_502_2_",
    className: "st0",
    d: "M20.1,28.3l-0.5-2.5l-0.5-2.5h-6.3H6.5L6,25.8l-0.5,2.5H20.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReward);
export default __webpack_public_path__ + "static/media/reward.e4937350a483a85e1f75b1740915b68d.svg";
export { ForwardRef as ReactComponent };